import type { Virtualizer } from '@tanstack/react-virtual';
import { createContext, useContext } from 'react';

export type VirtualizerContextType = Virtualizer<HTMLDivElement, Element>;

export const VirtualizerContext = createContext<VirtualizerContextType | undefined>(undefined);

export const useVirtualizerContext = (): VirtualizerContextType => {
    const virtualizer = useContext(VirtualizerContext);
    if (!virtualizer) throw new Error('No VirtualizerContext found.');
    return virtualizer;
};
